import React from 'react';

import { observer } from 'mobx-react';

import { PageTitle } from '../../../../shared/components/ui-components';
import { entityListStore } from '../../../stores/entityListStore';
import { EntityListFilterTabs } from './EntityListFilterTabs/EntityListFilterTabs';
import { AddEntityButton } from '../../../components/NgzAddEntityButton/NgzAddEntityButton';
import { ListMode } from '../NgzEntityList.settings';

type EntityListPageTitleProps = {
  listMode: ListMode;
};

const EntityListPageTitle = observer(({ listMode }: EntityListPageTitleProps) => {
  const { filteredEntityCount } = entityListStore;

  return (
    <PageTitle
      title={`Entities (${filteredEntityCount})`}
      tabs={<EntityListFilterTabs listMode={listMode} />}
    >
      <AddEntityButton variant="contained" size="medium" />
    </PageTitle>
  );
});

export { EntityListPageTitle };
